import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

//---------------------resource-listing------------------------------
export const fathResourceApi = async (data) => {
  const endPoint =
    `/resource/list` + `?` + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

//--------------------add-resource-------------------------------
export const addResourceApi = async (data) => {
  const endPoint = `/resource/add`;
  return await axios.post(endPoint, data, setMultiPartHeader());
};
//--------------------update-resource-------------------------------
export const updateResourceApi = async (data) => {
  const endPoint = `/resource/update`;
  return await axios.put(endPoint, data, setMultiPartHeader());
};
//--------------------single-details-------------------------------
export const resourceDetailsApi = async (id) => {
  const endPoint = `/resource/view/${id}`;
  return await axios.get(endPoint, setJwtToken());
};

//--------------------view---fund-history-list-------------------------------
export const fundHistoryListApi = async (data) => {
  const endPoint =
    `/resource/spent_resource` +
    `?` +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

//-----------------requested-fund-listing-details---------------------------------
export const fundRequestDetailsApi = async (id) => {
  return await axios.get(`/resource/aid_request_detail/${id}`, setJwtToken());
};

//--------------------decline-request----Paid-to-resource-------------------------------
export const requestActionApi = async (data) => {
  const endPoint = `/resource/cancel_aid`;
  return await axios.put(endPoint, data, setJwtToken());
};

//-----------------------change-status-----------------------------
export const changeResourceStatusApi = async (data) => {
  return await axios.put(`resource/change_status`, data, setJwtToken());
};

//-----------------------delete-resource-----------------------------
export const deleteResourceApi = async (id) => {
  return await axios.delete(`/resource/delete/${id}`, setJwtToken());
};
